import React, {useState} from 'react';

import DomainTablePage from '../../components/domainTablePage.js'
import {ASNDomainsPageResult} from '../../../../server/routes/asn.js'

export default function ASNWebsites({server, pageData} : {server: string, pageData: unknown}) {

    const typedPageData = pageData as ASNDomainsPageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <DomainTablePage 
            domainList={data.TechnologyDomains}
        />
	)
}
